import { render, staticRenderFns } from "./Islem.vue?vue&type=template&id=0b4a059e&scoped=true&"
import script from "./Islem.vue?vue&type=script&lang=js&"
export * from "./Islem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a059e",
  null
  
)

export default component.exports